type GetDynamicSlidesPerViewParams = {
    maxSlideWidth: number;
    minSlideWidth: number;
    slideWidth: number;
    snapToFullSlides: boolean;
    spaceBetweenSlides: number;
    swiperWidth: number;
    targetSlidesPerView: 'auto' | number;
};

// If a slide can not be fully visible, between 20% and 60% of the slide should be visible
const MAX_VISIBLE_THRESHOLD = 0.6;
const MIN_VISIBLE_THRESHOLD = 0.2;

export function getSnappedSlidesPerView({
    maxSlideWidth,
    minSlideWidth,
    slideWidth,
    snapToFullSlides,
    spaceBetweenSlides,
    swiperWidth,
    targetSlidesPerView,
}: GetDynamicSlidesPerViewParams): number {
    let maxSlidesPerView = swiperWidth / (minSlideWidth + spaceBetweenSlides);
    let minSlidesPerView = swiperWidth / (maxSlideWidth + spaceBetweenSlides);

    if (
        targetSlidesPerView !== 'auto' &&
        targetSlidesPerView > minSlidesPerView &&
        targetSlidesPerView < maxSlidesPerView
    ) {
        return targetSlidesPerView;
    }

    let slidesPerView = swiperWidth / (slideWidth + spaceBetweenSlides);

    if (targetSlidesPerView !== 'auto' && slidesPerView < targetSlidesPerView) {
        const snappedSlidesPerView = snapForMaxSlidesPerView(maxSlidesPerView);
        return snapToFullSlides ? Math.floor(snappedSlidesPerView) : snappedSlidesPerView;
    } else {
        const snappedSlidesPerView = snapForMinSlidesPerView(minSlidesPerView);
        return snapToFullSlides ? Math.ceil(snappedSlidesPerView) : snappedSlidesPerView;
    }
}

function snapForMaxSlidesPerView(slidesPerView: number): number {
    const integerPart = Math.floor(slidesPerView);
    const decimalPart = slidesPerView - integerPart;

    // slidesPerView cannot be larger, so every manipulation has to result in a smaller value
    if (decimalPart > MAX_VISIBLE_THRESHOLD) {
        return integerPart + MAX_VISIBLE_THRESHOLD;
    } else if (decimalPart < MIN_VISIBLE_THRESHOLD) {
        return integerPart;
    }

    return slidesPerView;
}

function snapForMinSlidesPerView(slidesPerView: number): number {
    const integerPart = Math.floor(slidesPerView);
    const decimalPart = slidesPerView - integerPart;

    // slidesPerView cannot be smaller, so every manipulation has to result in a larger value
    if (decimalPart > MAX_VISIBLE_THRESHOLD) {
        return integerPart + 1;
    } else if (decimalPart < MIN_VISIBLE_THRESHOLD) {
        return integerPart + MIN_VISIBLE_THRESHOLD;
    }

    return slidesPerView;
}
